import {Component} from '@angular/core';
import { NavController, NavParams ,ViewController ,ToastController} from 'ionic-angular';
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {Events} from 'ionic-angular';
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'confirm-password-popup',
  templateUrl: 'confirm-password-popup.html'
})
export class ConfirmPasswordPopup {

  username = ""
  password = ""

  constructor(private nav:NavController,
              private api:Api,
              private params: NavParams,
              private cartManager:CartManager,
              private msgManager:MsgManager,
              private viewController:ViewController,
              private toastController:ToastController,
              private events:Events,
              private gVLogger: GVLogger){
    // this.dropshipLocation = this.params.get("dropshipLocation");
    // this.gVLogger.log("dropship location : " + this.dropshipLocation);
    // this.companyName = this.params.get("companyName");

    // console.log("VVVVVV " + this.companyName)
    // this.dropshipLocation.companyName = this.companyName
    // this.getCountries();
    // this.getProvincesWhileEditing(this.dropshipLocation.country)
  }


  addAdress(){
    if(this.validateForm()){
      let body = {
        userName : this.username,
        pass : this.password
      }
      this.api.post("users/confirmPassword",body).map(res => res.json()).subscribe( data => {
        if(data.status === "200"){
          let obj = {
            "userName"  : this.username,
            "password"  : this.password,
            "status" : "Verified"
          }
          this.viewController.dismiss(obj);
        }else {
          this.api.toastMSG("Wrong user name or password!")
        }
      })
    }

  }


  validateForm(){
    if(this.username == "" || this.password == ""){
      this.gVLogger.log("form validation failed");

      this.toastMsg("User name and password cannot not be empty");
      return false;
    }else{
      this.gVLogger.log("form validation pass");
      return true;
    }
  }

  cancelPopup(){
    let obj = {
      "userName"  : "",
      "password"  : "",
      "status" : "Unverified"
    }
    this.viewController.dismiss(obj);
  }

  toastMsg(msg){
    let taost = this.toastController.create({
      message: msg,
      duration: 3000
    });
    taost.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/confirm-password-popup/confirm-password-popup.ts